
import Vue from "vue";
import { GetDynamicImage } from "../App.vue";

export default Vue.extend({
  name: "DynamicImage",
  props: {
    id: String,
    transitionId: String,
  },
  data() {
    return {
      content: "url(" + GetDynamicImage(this.id) + ")",
    };
  },
  created() {
    if (this.transitionId) {
      setTimeout(() => {
        this.content = "url(" + GetDynamicImage(this.transitionId) + ")";
      }, 720);
    }
  },
});
